<template>
  <div class="tw:flex tw:flex-col tw:md:flex-row tw:gap-y-3 tw:md:gap-x-3 tw:mb-6">
    <div v-for="card in cards" :key="card.id" class="tw:md:w-1/2">
      <PerformanceEmptyCard :icon="card.icon" :title="card.title" :hint="$t(card.hint)" />
    </div>
  </div>
  <div>
    <div class="tw:flex tw:flex-col tw:gap-y-1 tw:mb-4">
      <h2 class="tw:font-bold">{{ $t('performance_no_data_header') }}</h2>
      <p class="tw:text-sm">
        {{ $t('performance_no_data_subtext') }}
      </p>
    </div>
    <div class="tw:flex tw:flex-col tw:md:flex-row tw:md:gap-x-3 tw:gap-y-3">
      <PerformanceTipsCard
        v-for="tip in tips"
        :key="tip.id"
        :text="tip.text"
        :icon="tip.icon"
        :buttonLabel="tip.buttonLabel"
        :url="tip.url"
        :productName="tip.productName"
        :eventName="tip.eventName"
      />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import PerformanceEmptyCard from '@/components/homePage/performance/PerformanceEmptyCard.vue'
import PerformanceTipsCard from './PerformanceTipsCard.vue'
import { useStudioPlusCampaign } from '@/components/payment/queries'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const EyeIcon = new URL(`../../../assets/img/homepage/EyeIcon.png`, import.meta.url)
const ClicksIcon = new URL(`../../../assets/img/homepage/ClicksIcon.png`, import.meta.url)
const RateConnectIcon = new URL(`../../../assets/img/homepage/RateConnectIcon.png`, import.meta.url)
const HotelOffersIcon = new URL(`../../../assets/img/homepage/HotelOffersIcon.png`, import.meta.url)
const PropertyDetailsIcon = new URL(`../../../assets/img/homepage/PropertyDetailsIcon.png`, import.meta.url)

const { studioPlusCampaign, isExpiredSubscription } = useStudioPlusCampaign(selectedAccommodationId)
const cards = [
  { id: 0, title: 'rc_label_impressions', icon: EyeIcon, hint: 'infobubble_definition_views' },
  { id: 1, title: 'rc_label_clicks', icon: ClicksIcon, hint: 'infobubble_definition_clicks' },
]

const tips = computed(() => {
  return [
    {
      id: 0,
      text: 'performance_tip_rc',
      buttonLabel: 'performance_cta_rc',
      url: '/rate-connect',
      icon: RateConnectIcon,
      productName: 'Rate Connect',
      eventName: appAnalytics.events.HOMEPAGE_PERFORMANCE_NO_DATA_START_RC,
    },
    {
      id: 1,
      text: 'performance_tip_ho',
      buttonLabel:
        studioPlusCampaign.value && !isExpiredSubscription.value
          ? 'performance_cta_ho_subscriber'
          : 'performance_cta_ho',
      url: studioPlusCampaign.value && !isExpiredSubscription.value ? '/hotel-offers' : '/studio-plus/compare',
      icon: HotelOffersIcon,
      productName: 'Hotel Offers',
      eventName: appAnalytics.events.HOMEPAGE_PERFORMANCE_NO_DATA_UNLOCK_HO,
    },
    {
      id: 2,
      text: 'performance_tip_profile',
      buttonLabel: 'performance_profile_cta',
      url: '/property-details/basic-information',
      icon: PropertyDetailsIcon,
      productName: 'Property Details',
      eventName: appAnalytics.events.HOMEPAGE_PERFORMANCE_NO_DATA_UPDATE_PD,
    },
  ]
})
</script>
